import { ISO3166 } from '@pelicargo/utils';
import { useMemo } from 'react';
import { Control, FieldValues, useWatch } from 'react-hook-form';

export const useIsoStates = (control: Control<FieldValues>, countryField: string = 'country') => {
  const country = useWatch({ control, name: countryField });
  const states = useMemo(() => {
    if (!country || !(country in ISO3166)) return [];
    return Object.entries(ISO3166[country as keyof typeof ISO3166]).map(([code, name]) => ({
      label: name,
      value: code,
    }));
  }, [country]);

  return states;
};
